import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  ViewContainerRef, ComponentRef, ComponentFactoryResolver, ViewChild, OnChanges, SimpleChanges, OnDestroy
} from '@angular/core';
import * as _ from 'lodash';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'cartrule-condition-container',
  templateUrl: './cartrule-condition.component.html',
  styleUrls: ['./cartrule-condition.component.scss']
})
export class CartruleConditionComponent implements OnInit, OnChanges {
  @ViewChild('conditions', {read: ViewContainerRef}) conditionsDom: ViewContainerRef;
  cmpRefs: ComponentRef<CartruleConditionComponent>[] = [];

  @Input() allMenu;
  // TODO improve this to not keep on passing it to child, maybe get from store straight away ?
  @Input() displayParser;
  @Input() currentMenu;
  @Input() val: Object;
  @Output() onDelete = new EventEmitter<any>();
  @Output() onUpdate = new EventEmitter<any>();
  showDelete = false;
  showUpdate = false;
  textDisplayParsed = [];
  allMenuObj;
  submenuToAdd = '';
  initiated = false;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {
    this.showDelete = this.onDelete.observers.length > 0;
    this.showUpdate = this.onUpdate.observers.length > 0;
    this.allMenuObj = this.allMenu.reduce((acc, cur) => {
      acc[cur.name] = cur;
      return acc;
    }, {});
    this.textDisplayParsed = this.currentMenu.text_display.split(/({{.*?}})/g).map(s => {
      let parsedVal = s.split(/{{(.*)}}/);
      return {
        text: s,
        text_parsed: parsedVal.length > 1 ? parsedVal[1] : ''
      };
    });
    if (this.val && this.currentMenu && this.allMenu) {
      this.val = {
        ..._.omit(this.val, ['type', 'is_value_processed']),
        type: this.currentMenu.name,
        is_value_processed: null
      };
      this.constructAll(this.val, {});
    }
    this.initiated = true;
  }

  onDeletePressed() {
    if (this.showDelete) {
      this.onDelete.emit();
    }
  }

  onUpdatePerformed(val) {
    if (this.showUpdate) {
      this.onUpdate.emit(val);
    }
  }

  runDelete(index) {
    return () => {
      if (index === null || typeof index === 'undefined') {
        return;
      }
      if (Array.isArray(this.val['conditions'])) {
        this.val['conditions'].splice(index, 1);
        this.cmpRefs[index].destroy();
        this.updateParent();
      }
    };
  }
  runUpdate(index) {
    return (val) => {
      if (index === null || typeof index === 'undefined') {
        return;
      }
      if (Array.isArray(this.val['conditions'])) {
        this.val['conditions'][index] = val;
        // recursively update parent until no onUpdate method
        this.updateParent();
      }
    };
  }

  getAllowedAttributes() {
    return this.currentMenu.allowed_attributes.map(s => s.name);
  }

  selectAttribute(val, oldVal = null) {
    let attributes = this.getAllowedAttributes();
    if (attributes.indexOf(val) > -1) {
      this.val['attribute'] = val;
    } else {
      this.val['attribute'] = oldVal;
    }
    this.updateParent();
    // re add operator to check if it is still applicable otherwie we reset
    this.selectOperator(this.val['operator'], null);
  }

  getAllowedOperators() {
    if (!this.val['attribute']) {
      return [];
    }
    let attr = this.currentMenu.allowed_attributes.find(s => s.name === this.val['attribute']);
    if (attr) {
      return attr.allowed_operators;
    }
    return [];
  }

  selectOperator(val, oldVal = null) {
    let operators = this.getAllowedOperators();
    if (operators.indexOf(val) > -1) {
      this.val['operator'] = val;
    } else {
      this.val['operator'] = oldVal;
    }
    this.setValue(this.val['value'], '');
    this.updateParent();
  }

  isValueAllowed() {
    return !!this.val['operator'] || !!this.val['aggregator'];
  }

  isRestrictValue() {
    return this.currentMenu.restrict_values.length > 0;
  }

  getRestrictValues() {
    return this.currentMenu.restrict_values;
  }

  setValue(val, oldVal = '') {
    if (this.isValueAllowed()) {
      this.val['value'] = val;
    } else {
      this.val['value'] = oldVal;
    }
    this.updateParent();
  }

  getAllowedAggregators() {
    return this.currentMenu.allowed_aggregators;
  }

  selectAggregator(val, oldVal = null) {
    let aggregators = this.getAllowedAggregators();
    if (aggregators.indexOf(val) > -1) {
      this.val['aggregator'] = val;
    } else {
      this.val['aggregator'] = oldVal;
    }
    this.updateParent();
  }

  getAllowedConditions() {
    return this.currentMenu.allowed_submenu;
  }

  addCondition(val) {
    this.submenuToAdd = '';
    if (!val) {
      return;
    }
    if (this.currentMenu.allowed_submenu.indexOf(val) > -1) {
      let conditionToPush = {
        type: val
      };
      if (!this.val['conditions']) {
        this.val['conditions'] = [];
      }
      this.val['conditions'].push(conditionToPush);

      this.syncCondition(this.val['conditions']);
    }
    this.updateParent();
    this.submenuToAdd = '';
  }

  syncCondition(conditions) {
    this.cmpRefs.forEach(s => {
      s.destroy();
    });
    this.cmpRefs = [];
    if (!conditions) {
      return;
    }
    conditions = conditions.filter(condition => !!this.allMenuObj[condition.type]);
    conditions.forEach(condition => {
      let factory = this.componentFactoryResolver.resolveComponentFactory(CartruleConditionComponent);
      this.cmpRefs.push(this.conditionsDom.createComponent(factory));
      let index = this.cmpRefs.length - 1;
      this.cmpRefs[index].instance.displayParser = this.displayParser;
      this.cmpRefs[index].instance.allMenu = this.allMenu;
      this.cmpRefs[index].instance.currentMenu = this.allMenuObj[condition.type];
      this.cmpRefs[index].instance.val = condition;
      this.cmpRefs[index].instance.onDelete.subscribe(() => {
        this.runDelete(index)();
      });
      this.cmpRefs[index].instance.onUpdate.subscribe(originalValue => {
        this.runUpdate(index)(originalValue);
      });
    });
    this.val['conditions'] = conditions;
  }

  updateParent() {
    if (this.showUpdate) {
      this.onUpdatePerformed(this.val);
    }
  }

  constructAll(newVal, oldVal) {
    this.selectAttribute(newVal['attribute'], oldVal['attribute']);
    this.selectOperator(newVal['operator'], oldVal['operator']);
    this.setValue(newVal['value'], oldVal['value']);
    this.selectAggregator(newVal['aggregator'], oldVal['aggregator']);
    this.syncCondition(newVal['conditions']);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.initiated) {
      return;
    }
    // make sure not to use destroyed component
    if (!changes.val) {
      return;
    }
    if (changes.val.currentValue && this.currentMenu && this.allMenu) {
      this.constructAll(changes.val.currentValue, {});
    }
  }
}
